<template>
  <div class="reset-trade-pwd">
    <div class="content">
      <!-- 模块1：身份验证 -->
      <div v-show="step === 1" class="verify-identity">
        <h2 class="title">{{ $t('m000018') }}</h2>
        <van-form @submit="onVerifySubmit">
          <van-field
            v-model="verifyForm.id_card"
            :placeholder="$t('m000019')"
          />
          <van-field
            v-model="verifyForm.email"
            :placeholder="$t('m000020')"
          />
          <div class="btn-wrap">
            <van-button block type="primary" native-type="submit" class="submit-btn">{{ $t('m000035') }}</van-button>
          </div>
        </van-form>
      </div>

      <!-- 模块2：设置密码 -->
      <div v-show="step === 2" class="set-password">
        <h2 class="title step-2">{{ $t('m000004') }}</h2>
        <van-form @submit="onResetSubmit">
          <van-field
            v-model="resetForm.password"
            :type="passwordVisible ? 'text' : 'password'"
            :placeholder="$t('m000005')"
            class="password-field"
            inputmode="numeric"
          >
            <template #right-icon>
              <template v-if="bgColor == 'black-theme'">
                <img src="@/assets/images/icon_eye_close-dark.png" class="eye" v-show="!passwordVisible" @click="togglePasswordVisibility('password')">
                <img src="@/assets/images/icon_eye_open-dark.png" class="eye" v-show="passwordVisible" @click="togglePasswordVisibility('password')">
              </template>
              <template v-else>
                <img src="@/assets/images/icon_eye_close.png" class="eye" v-show="!passwordVisible" @click="togglePasswordVisibility('password')">
                <img src="@/assets/images/icon_eye_open.png" class="eye" v-show="passwordVisible" @click="togglePasswordVisibility('password')">
              </template>
            </template>
          </van-field>
          <van-field
            v-model="resetForm.repeat_password"
            :type="confirmPasswordVisible ? 'text' : 'password'"
            :placeholder="$t('m000006')"
            class="password-field"
            inputmode="numeric"
          >
            <template #right-icon>
              <template v-if="bgColor == 'black-theme'">
                <img src="@/assets/images/icon_eye_close-dark.png" class="eye" v-show="!confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
                <img src="@/assets/images/icon_eye_open-dark.png" class="eye" v-show="confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
              </template>
              <template v-else>
                <img src="@/assets/images/icon_eye_close.png" class="eye" v-show="!confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
                <img src="@/assets/images/icon_eye_open.png" class="eye" v-show="confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
              </template>
            </template>
          </van-field>
          <div class="tips">
            <span class="text" :class="{ 'success': isPasswordLength }">
              <van-icon v-if="isPasswordLength" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000007') }}
            </span>
            <span class="text" :class="{ 'success': isPasswordNumber }">
              <van-icon v-if="isPasswordNumber" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000008') }}
            </span>
            <span class="text" :class="{ 'success': isPasswordMatch }">
              <van-icon v-if="isPasswordMatch" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000009') }}
            </span>
          </div>
          <div class="btn-wrap">
            <van-button block type="primary" native-type="submit" class="submit-btn" :class="{ disabled: !isResetBtnEnabled }">{{ $t('m000035') }}</van-button>
          </div>
        </van-form>
      </div>
    </div>

    <div class="footer">
      <span class="text">{{ $t('m000010') }} </span>
      <span class="link" @click="contactService">{{ $t('m000011') }}</span>
    </div>
    <global-action-sheet v-model="showActionSheet" />
  </div>
</template>

<script>
import { Toast, Form, Field, Button, Icon } from 'vant'
import GlobalActionSheet from '@/components/GlobalActionSheet.vue'
import { closeWebView } from "@/utils/hybirdMethods";

export default {
  name: 'resetTradePwd',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
    GlobalActionSheet
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    // 重置密码按钮状态
    isResetBtnEnabled() {
      return this.isPasswordLength && this.isPasswordNumber && this.isPasswordMatch
    },
    isPasswordLength() {
      return this.resetForm.password.length === 6
    },
    isPasswordNumber() {
      return /^\d+$/.test(this.resetForm.password)
    },
    isPasswordMatch() {
      const { password, repeat_password } = this.resetForm
      return password && repeat_password && password === repeat_password
    }
  },
  data() {
    return {
      step: 1,
      verifyForm: {
        id_card: '',
        email: ''
      },
      resetForm: {
        password: '',
        repeat_password: ''
      },
      passwordVisible: false,
      confirmPasswordVisible: false,
      showActionSheet: false
    }
  },
  methods: {
    onVerifySubmit() {
      const { id_card, email } = this.verifyForm
      if (!id_card) {
        Toast(this.$t('m000021'))
        return
      }
      if (!email) {
        Toast(this.$t('m000022'))
        return
      }
      this.$apis.verifyAccountInfo(this.verifyForm).then(res => {
        if ( !res.msg ) {
            
            this.verifyInfo = res
            this.step = 2
        }
      })
    },

    onResetSubmit() {
      const { password, repeat_password } = this.resetForm
      if (!password) {
        Toast(this.$t('m000014'))
        return
      }
      if (!repeat_password) {
        Toast(this.$t('m000016'))
        return
      }
      if (password !== repeat_password) {
        Toast(this.$t('m000017'))
        return
      }
      this.$apis.setTradePwd({ ...this.resetForm, sign: this.verifyInfo.sign }).then(res => {
        if ( !res.msg ) {
          Toast(this.$t('m000032'))
          setTimeout(() => {
            closeWebView()
          }, 1000)
        }
      })
    },

    togglePasswordVisibility(field) {
      if (field === 'password') {
        this.passwordVisible = !this.passwordVisible
      } else if (field === 'repeat_password') {
        this.confirmPasswordVisible = !this.confirmPasswordVisible
      }
    },

    contactService() {
      this.showActionSheet = true
    }
  }
}
</script>

<style lang="less" scoped>
.reset-trade-pwd {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  
  .content {
    flex: 1;
    padding: 40px 40px 0;
  }

  .title {
    font-size: 34px;
    color: #0F0F2F;
    margin-bottom: 30px;
    font-weight: 500;
    &.step-2 {
      font-size: 52px;
    }
  }

  .btn-wrap {
    margin-top: 368px;
    display: flex;
    align-items: center;
    justify-content: center;

    .submit-btn {
      width: 568px;
      height: 104px;
      border-radius: 200px;
      background: #17161C;
      border: none;
      font-size: 32px;
      font-weight: 500;
      &.disabled {
        opacity: 0.5;
      }
    }
  }

  .tips {
    color: #0F0F2F;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .text {
      color: #747377;
      font-size: 28px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &.success {
        color: #009a61;
      }

      .success-icon {
        color: #009a61;
        margin-right: 5px;
      }
      .unit {
        margin-right: 22px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #444;
      }
    }
  }

  .footer {
    padding: 30px 40px 60px;
    text-align: center;
    font-size: 28px;
    margin-top: auto;

    .text {
      color: #A2A2A2;
    }

    .link {
      color: #328CF4;
      text-decoration: underline;
    }
  }
}

::v-deep .van-field {
  height: 116px;
  background: transparent;
  padding: 0 !important;

  .van-field__body {
    input {
      color: #0F0F2F;
      font-size: 32px;
      font-weight: 500;
      &::placeholder {
        color: #B9B9B9;
      }
    }
  }
}

.password-field {
  ::v-deep .van-field__right-icon {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 18px;

    .eye {
      width: 50px;
      height: 50px;
    }
  }
}

.black-theme {
  .reset-trade-pwd {
    background: #1B1C24;
    .title {
      color: white;
    }
    .tips {
      color: #9D9D9F;
    }
    .text {
      color: white;
    }
    .unit {
      background: white !important;
    }
    ::v-deep .van-field {
      .van-field__body {
        input {
          color: white;
          font-size: 32px;
          font-weight: 500;
          &::placeholder {
            color: #B9B9B9 !important;
          }
        }
      }
    }
  }
}

</style>